import { connect } from 'react-redux';
import SearchArtistsComponent from '../components/SearchArtistsComponent';

const mapStateToProps = (state) => {
    const isMobile = state.clientInfo.isMobile;

    return {
        device: isMobile || 'desktop',
    };
};

// passing an empty object for mapDispatchToProps to avoid dispatch being passed on and causing prop-types-exact to complain
const SearchArtistsContainer = connect(mapStateToProps, {})(SearchArtistsComponent);

export default SearchArtistsContainer;
